<div class="pages">
  <div
    [ngClass]="{
      'page': 1,
      'disabled': pageNumber === 1
    }"
    (click)="goToPreviousPage()"
  >
    <i class="fa-regular fa-angle-left"></i>
  </div>

  @for (option of selectorOptions; track option.id) {
    <div
      [ngClass]="{
        'page': 1,
        'active': ''+pageNumber === option.id
      }"
      (click)="goToPage(+option.id)"
    >
      {{option.name}}
    </div>
  }

  <div
    [ngClass]="{
      'page': 1,
      'disabled': pageNumber === getPageQty() || getPageQty() === 0
    }"
    (click)="goToNextPage()"
  >
    <i class="fa-regular fa-angle-right"></i>
  </div>
</div>
